const config = {

    BASE_URL: "" + process.env.REACT_APP_BASE_URL,
  
  };
  
  export default config;
  
